import { useEffect, useRef } from "react";
import staticTemplate from "./static-template.html?raw";
import "./static.css";

export default function Home() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const menuButton = root.querySelector<HTMLButtonElement>(".menu-toggle");
    const menu = root.querySelector<HTMLElement>("#mobile-navigation");
    const toggleMenu = () => {
      if (!menuButton || !menu) return;
      const open = !menu.classList.contains("mobile-menu--open");
      menu.classList.toggle("mobile-menu--open", open);
      menu.setAttribute("aria-hidden", String(!open));
      menuButton.setAttribute("aria-expanded", String(open));
      const icon = menuButton.querySelector("i");
      if (icon) icon.className = open ? "ri-close-line" : "ri-menu-3-line";
    };
    const closeMenu = () => {
      if (!menuButton || !menu) return;
      menu.classList.remove("mobile-menu--open");
      menu.setAttribute("aria-hidden", "true");
      menuButton.setAttribute("aria-expanded", "false");
      const icon = menuButton.querySelector("i");
      if (icon) icon.className = "ri-menu-3-line";
    };
    menuButton?.addEventListener("click", toggleMenu);
    const menuLinks = [...root.querySelectorAll<HTMLAnchorElement>("#mobile-navigation a")];
    menuLinks.forEach((link) => link.addEventListener("click", closeMenu));

    const carouselButtons = [...root.querySelectorAll<HTMLButtonElement>("[data-scroll-prev], [data-scroll-next]")];
    const scrollCarousel = (event: Event) => {
      const button = event.currentTarget as HTMLButtonElement;
      const id = button.dataset.scrollPrev || button.dataset.scrollNext;
      const track = id ? root.querySelector<HTMLElement>(`[data-scroll-track="${id}"]`) : null;
      const card = track?.querySelector<HTMLElement>("article");
      if (!track || !card) return;
      const direction = button.dataset.scrollPrev ? -1 : 1;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 20), behavior: "smooth" });
    };
    carouselButtons.forEach((button) => button.addEventListener("click", scrollCarousel));

    return () => {
      menuButton?.removeEventListener("click", toggleMenu);
      menuLinks.forEach((link) => link.removeEventListener("click", closeMenu));
      carouselButtons.forEach((button) => button.removeEventListener("click", scrollCarousel));
    };
  }, []);

  return <div ref={rootRef} dangerouslySetInnerHTML={{ __html: staticTemplate }} />;
}
